import React from 'react';
import { isNil } from 'lodash';
import cx from 'classnames';
import styles from './Overview.module.scss';
import DocEditor from 'js/components/elements/editors/DocEditor';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_SCHEMA_SPEC_DOC_REQUEST } from 'js/constants/actionTypes';
import SchemaViewer from 'js/components/elements/schema-viewer/SchemaViewer';
import { useResourceDoc } from 'new/hooks/adapters/useResourceDoc';
import { RESOURCE_TYPE_SCHEMA_SPECS } from 'js/constants/resourceTypes';
import { useSchemaSamples } from 'new/hooks/adapters/useSchemaSamples';

interface SchemaSpecOverviewProps {
  resource: any;
}

export const SchemaSpecOverview = (props: SchemaSpecOverviewProps) => {
  const { resource } = props;
  const resourceId = resource?.id;
  const { flatSamples, flatSchemas, lastUpdated, nestedSamples } = useSchemaSamples(resource?.id);
  const doc = useResourceDoc(RESOURCE_TYPE_SCHEMA_SPECS, resourceId);
  const isLoadingDoc = useIsLoading(GET_SCHEMA_SPEC_DOC_REQUEST);

  return (
    <div
      className={cx(styles.overviewContainer, styles.schemaSpecOverviewContainer, 'detail-view')}
    >
      <div className="tab-content">
        {!isNil(doc) && !isLoadingDoc ? (
          <DocEditor data={resource} doc={doc} readOnly isLoading={isLoadingDoc} />
        ) : null}
        <h2 className={styles.schemaHeader}>Schema & Samples</h2>
        <SchemaViewer
          schema={flatSchemas}
          resource={resource}
          resourceType={RESOURCE_TYPE_SCHEMA_SPECS}
          samples={flatSamples}
          showCharacteristics={false}
          nestedSamples={nestedSamples}
          samplesUpdatedAt={lastUpdated}
          hideExpandMetaToggle
        />
      </div>
    </div>
  );
};
